import { Button, Grid, Typography } from "@mui/material";
// import Logo from "../../assets/images/logo.png";
import laptop from "../../assets/images/ipad.png";
import "./style.scss";
import { Link } from "react-router-dom";
const AdsComponent = ({ variant }) => {
  return (
    <div
      className={`adscontainer2 payout-competition-banner-2 ${
        (variant === "small" && "small") || (variant === "tall" && "tall")
      }`}
    >
      <a href="https://discord.com/invite/W5aKKmPRdR">
        {/* <img className="logo" src={Logo} alt="" /> */}
        <Typography
          className="competition_banner_text"
          component={variant === "small" ? "h3" : "h3"}
        >
          Exciting giveaways <br />
          on the run up to Christmas
        </Typography>

        <Button style={{ zIndex: "1" }} className="enter-btn">
          Enter Competiton
        </Button>
        <img src={laptop} alt="laptop" className="laptop" />
      </a>
    </div>
  );
};

export default AdsComponent;
